import { memo } from "react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { LayoutGrid, List } from "lucide-react";

type ViewMode = 'detail' | 'batch';

interface ViewModeToggleProps {
  viewMode: ViewMode;
  onChange: (mode: ViewMode) => void;
}

/**
 * 상세 보기 / 일괄 처리 뷰 전환 토글 (로그인 사용자에게만 노출).
 * state(viewMode)는 Home이 소유하고 value/onChange만 받는 presentational 컴포넌트.
 */
export const ViewModeToggle = memo(function ViewModeToggle({ viewMode, onChange }: ViewModeToggleProps) {
  return (
    <div className="flex justify-end p-4">
      <ToggleGroup
        type="single"
        value={viewMode}
        onValueChange={(value) => {
          if (value) onChange(value as ViewMode);
        }}
        className="h-9"
      >
        <ToggleGroupItem value="detail" aria-label="상세 보기" className="data-[state=on]:bg-indigo-100 data-[state=on]:text-indigo-700">
          <LayoutGrid className="h-4 w-4 mr-2" />
          상세 보기
        </ToggleGroupItem>
        <ToggleGroupItem value="batch" aria-label="일괄 처리" className="data-[state=on]:bg-indigo-100 data-[state=on]:text-indigo-700">
          <List className="h-4 w-4 mr-2" />
          일괄 처리
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
});
